import React, { useEffect } from 'react';
import { Link } from "react-router-dom";

const Service = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, [])
    // Dynamic data for services
    const services = [
        {
            icon: "flaticon-graphic-design",
            title: "Best Designs",
            description: "Offering exquisite and unique designs crafted with precision to match your style and needs.",
            link: "#"
        },
        {
            icon: "flaticon-diamond",
            title: "Certified Jewellery",
            description: "All our jewellery is certified for authenticity, ensuring you get the best quality and value.",
            link: "#"
        },
        {
            icon: "flaticon-certificate",
            title: "BIS Hallmarked",
            description: "All our products are BIS hallmarked, certifying their purity and quality.",
            link: "#"
        },
        {
            icon: "flaticon-customization",
            title: "Customization Options",
            description: "We offer customization options to create designs that truly reflect your personality.",
            link: "#"
        },
    ];

    return (
        <div>
            <style>
                {`
                    .services-section-two .service-block-two {
                        margin-bottom: 10px;
                    }

                    .services-section-two .inner-box {
                        padding: 20px;
                        border: 1px solid #ddd;
                        border-radius: 5px;
                        transition: all 0.3s ease;
                    }

                    .services-section-two .inner-box:hover {
                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    }

                    @media (max-width: 768px) {
                        .services-section-two .service-block-two {
                            width: 100%;
                            margin-bottom: 20px;
                        }

                        .services-section-two .inner-box {
                            height: auto;
                        }

                        .services-section-two .content {
                            margin-left: 0;
                        }
                    }
                `}
            </style>
            {/* Services Section */}
            <section className="services-section-two">
                <div className="auto-container">
                    {/* Section Title */}
                    <div className="sec-title">
                        <h2>Our Services</h2>
                        <div className="text">
                            We offer a wide range of services designed to meet your needs and provide exceptional quality. Explore our offerings to find the perfect solution for you.
                        </div>
                    </div>

                    {/* Services Grid */}
                    <div className="row clearfix">
                        {services.map((service, index) => (
                            <div
                                key={index}
                                className="service-block-two col-lg-6 col-md-6 col-sm-12"
                            >
                                <div
                                    className="inner-box wow fadeInLeft "
                                    style={{ height: "25vh" }}
                                    data-wow-delay={`${index * 300}ms`}
                                    data-wow-duration="1500ms"
                                >
                                    <div className="content" >
                                        <div className="icon-box ">
                                            <span className={`icon ${service.icon}`}></span>
                                        </div>
                                        <h3 className='mt-3'>
                                            <Link to={service.link}>{service.title}</Link>
                                        </h3>
                                        <div className="text">{service.description}</div>
                                        
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Service;